import React, { useEffect, useState } from "react";
import { Row, Col, Image } from "react-bootstrap";
import "./firmDetails.css"
import Select from "react-select";
import { getFromLS, setToLS } from "../../utils/storage";
import { useNavigate } from "react-router-dom";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { makeCygnusApiCall } from "../../api/api";
import { CustomButton } from "../../reusable-components/CustomButtonComponent/button";

function listToDict(list, idGen) {
    let dict = {}
    list.forEach((element) => {
        const dictKey = idGen(element)
        dict[dictKey] = element
    })
    return dict
}

function optionRenderer(options) {
    const optionRendered = []
    for (let opt in options) {
        if (options != [] && options[opt] != "" && options[opt] != undefined) {
            optionRendered.push({ value: options[opt], label: options[opt] })
        }
    }
    return optionRendered
}

function FirmDetails(props) {
    let token = localStorage.getItem("token");
    let navigate = useNavigate();
    const [allVendors, setAllVendors] = useState([]);
    // Mapper to manage state changes in allVendors
    const [allVendorsMapper, setAllVendorsMapper] = useState([]);
    // Filtered apps state holder
    const [filteredSelectedApps, setFilteredSelectedApps] = useState([])
    const [filteredRemainingApps, setFilteredRemainingApps] = useState([])
    const [filteredComingSoonApps, setFilteredComingSoonApps] = useState([])
    const [activeVendors, setActiveVendors] = useState([]);

    const [vendorCategories, setVendorCategories] = useState([]);
    const [vendorCategoriesOptions, setVendorCategoriesOptions] = useState(optionRenderer(vendorCategories));
    const [selectedApps, setSelectedApps] = useState([])
    const [selectedAppsMapper, setSelectedAppsMapper] = useState([])
    const [remainingApps, setRemainingApps] = useState([])
    const [remainingAppsMapper, setRemainingAppsMapper] = useState([])
    const [comingSoonApps, setComingSoonApps] = useState([])
    const [comingSoonAppsMapper, setComingSoonAppsMapper] = useState([])
    const [isSelectOptionsLoading, setIsSelectOptionsLoading] = useState(true)
    const [searchEnabled, setSearchEnabled] = useState(false)
    const [isFilterOn, setIsFilterOn] = useState(false)

    const [integration_apps, setIntegrationApps] = useState([])
    const [intelligence_apps, setIntelligenceApps] = useState([])
    const [automation_apps, setAutomationApps] = useState([])

    // Setting page url for helper function
    useEffect(() => {
        setToLS("url", ["myapps"])
    }, [])

    useEffect(() => {
        const getVendors = async () => {
            const data = await makeCygnusApiCall({
                type: "GET",
                payload: {},
                url: `/firm_vendors/`,
                show_message: false,
                customized_success_message: "Successful retrieved your vendors.",
                customized_failure_message: "Unable to fetch your vendors, please try again. If the problem persists, please contact support and attach a screenshot.",
                customized_error_message: "Error occured while fetching your vendors, please contact support and attach a screenshot.",
                isblob: false
            })
            if (data.success) {
                let abc = data["data"].map((el) => {
                    return {
                        label: el.VendorName,
                        value: el.VendorCode,
                    };
                });
                localStorage.setItem(
                    "initialFirmVendors",
                    JSON.stringify(data["data"])
                );
                setActiveVendors(data["data"])
                const dt = await makeCygnusApiCall({
                    type: "GET",
                    payload: {},
                    url: `/vendors/`,
                    show_message: false,
                    customized_success_message: "Successful retrieved vendors.",
                    customized_failure_message: "Unable to fetch all vendors, please try again. If the problem persists, please contact support and attach a screenshot.",
                    customized_error_message: "Error occured while fetching all vendors, please contact support and attach a screenshot.",
                    isblob: false
                })
                if (dt.success) {
                    if (dt["data"]) {
                        dt["data"].sort((a, b) => (a.VendorName > b.VendorName) ? 1 : ((b.VendorName > a.VendorName) ? -1 : 0))
                        setAllVendors(dt["data"]);
                        setVendorCategories([
                            ...new Set(dt["data"].map((el) => el.Category)),
                        ]);
                    }
                }
            }
        }
        getVendors()
    }, []);

    const getAllIntegrationWorkflowsApps = async () => {
        const data = await makeCygnusApiCall({
            type: "GET",
            payload: {},
            url: `/my_flows/`,
            show_message: false,
            customized_success_message: "Successful retrieved your integration flow apps.",
            customized_failure_message: "Unable to fetch your integration flow apps, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while fetching your integration flow apps, please contact support and attach a screenshot.",
            isblob: false
        })
        if (data.success) {
            console.log("INTEGRATIUON FLOWS:", data.data)
            const integration_apps = []
            for (let flow in data.data) {
                integration_apps.push(data.data[flow].TargetVendorId)
                integration_apps.push(data.data[flow].SourceVendorId)
            }
            setIntegrationApps(integration_apps)
        }
    };

    const getAllIntelWorkflowsApps = async () => {
        const data = await makeCygnusApiCall({
            type: "GET",
            payload: {},
            url: `/my_flows/intelligence/`,
            show_message: false,
            customized_success_message: "Successful retrieved your intelligence flow apps.",
            customized_failure_message: "Unable to fetch your intelligence flow apps, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while fetching your intelligence flow apps, please contact support and attach a screenshot.",
            isblob: false
        })
        if (data.success) {
            console.log("INTELLIGENCE FLOWS:", data.data)

            const intelligence_apps = []
            for (let flow in data.data) {
                for (let vendor in data.data[flow].SourceVendors) {
                    intelligence_apps.push(data.data[flow].SourceVendors[vendor].VendorId)
                }

                for (let vendor in data.data[flow].TargetVendors) {
                    intelligence_apps.push(data.data[flow].TargetVendors[vendor].VendorId)
                }
            }
            setIntelligenceApps(intelligence_apps)
        }
    };

    const getAllAutomationWorkflowsApps = async () => {
        const data = await makeCygnusApiCall({
            type: "GET",
            payload: {},
            url: `/my_flows/bot/`,
            show_message: false,
            customized_success_message: "Successful retrieved your automation flow apps.",
            customized_failure_message: "Unable to fetch your automation flow apps, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while fetching your automation flow apps, please contact support and attach a screenshot.",
            isblob: false
        })
        if (data.success) {
            console.log("AUTOMATION FLOWS:", data.data)

            const automationapps = []
            for (let flow in data.data) {
                for (let vendor in data.data[flow].SourceVendors) {
                    automationapps.push(data.data[flow].SourceVendors[vendor].VendorId)
                }

                for (let vendor in data.data[flow].TargetVendors) {
                    automationapps.push(data.data[flow].TargetVendors[vendor].VendorId)
                }
            }
            setAutomationApps(automationapps)
        }
    };

    useEffect(() => {
        getAllIntegrationWorkflowsApps()
        getAllIntelWorkflowsApps()
        getAllAutomationWorkflowsApps()
    }, [])

    useEffect(() => {
        const appset = [...integration_apps, ...intelligence_apps, ...automation_apps]
        setToLS("appset", appset)
    }, [integration_apps, intelligence_apps, automation_apps])



    useEffect(() => {
        // THIS USE EFFECT IS JUST FOR FORMATTING THE API RESPONSES
        // By default set allVendors as inactive
        for (let vendor in allVendors) {
            allVendors[vendor].Active = "N"
        }
        // Mark activeVendors from api as selected Apps and turn their status active "Y" in all vendors
        for (let act in activeVendors) {
            for (let vendor in allVendors) {
                if (activeVendors[act].VendorCode == allVendors[vendor].VendorCode) {
                    allVendors[vendor].Active = activeVendors[act].Active
                } else {
                    continue
                }
            }
        }

        // We declare the remaining apps i.e. allVendors-selectedApps as remaining apps

        for (let vendorApp in allVendors) {
            if (allVendors[vendorApp].VendorScope == "future") {
                comingSoonApps.push(allVendors[vendorApp])
            } else {
                if (allVendors[vendorApp].Active == "Y") {
                    selectedApps.push(allVendors[vendorApp])
                } else {
                    remainingApps.push(allVendors[vendorApp])
                }
            }
        }


        // set default selectedApps mapper and remainingApps mapper
        setSelectedAppsMapper([...selectedApps])
        setRemainingAppsMapper([...remainingApps])
        setComingSoonAppsMapper([...comingSoonApps])

        // Set the default mapper state for allVendors
        setAllVendorsMapper([...selectedApps, ...remainingApps, ...comingSoonApps])
    }, [allVendors])

    // We need dictionary of dictionary for mapping the elements 
    const all_vendors = listToDict(allVendors, (item) => item.VendorCode)

    const [handleVendorSaveApiFlag, setHandleVendorSaveApiFlag] = useState()
    // To save the selected vendors
    const handleVendorsSave = async () => {
        setHandleVendorSaveApiFlag(true)
        let selectedData = selectedApps.map((elem) => {
            return {
                VendorCode: elem.VendorCode,
                VendorName: elem.VendorName,
                Active: elem.Active,
            }
        });
        let notSelectedData = remainingApps.map((elem) => {
            return {
                VendorCode: elem.VendorCode,
                VendorName: elem.VendorName,
                Active: elem.Active,
            }
        });

        let formattedData = [...selectedData, ...notSelectedData]
        const data = await makeCygnusApiCall({
            type: "POST",
            payload: formattedData,
            url: `/firm_vendors/`,
            show_message: false,
            customized_success_message: "Successful saved your apps.",
            customized_failure_message: "Unable to save your apps, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while saving your apps, please contact support and attach a screenshot.",
            isblob: false
        })
        if (data.success) {
            transportTo()
        }
        setHandleVendorSaveApiFlag(true)
    };

    // Vendor app card renderer
    const VendorCard = props => {
        // console.log("VENDOR CARD PROPS: ", props)
        const appset = new Set(getFromLS("appset"))

        const isDisabled = (props.disabled ? true : false)
        const Holder = ({ children }) => {
            const isActive = (props.vendor.Active == "Y" ? true : false)
            const selectApp = (vendorName) => {
                if (!isDisabled) {
                    selectionUpdator(vendorName)
                } else {
                    console.log("This app is disabled.")
                }
            };
            return (
                <div className="wrap">
                    <div
                        className={isActive ? 'ed' : undefined}
                        onClick={(e) => selectApp(props.vendor.VendorName)}
                    >
                        <div className={isDisabled ? "disabled" : undefined}>
                            {children}
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <>
                {
                    appset.has(props.vendor.VendorId) ?
                        <OverlayTrigger
                            trigger="hover"
                            placement="top"
                            overlay={
                                <Popover id="popover-basic">
                                    <Popover.Body>
                                        <p>Cannot deselect apps connected to flows that already exist for the firm. Please remove the flows to deselect the apps.</p>
                                    </Popover.Body>
                                </Popover>
                            }
                        >
                            <Col md={2} className="text-center vendor-wrapper popover-basic">
                                <Holder>
                                    <div className="logo-wrapper">
                                        <Image src={props.vendor.VendorLogoLink} className="vendor-logo" rounded />
                                    </div>
                                </Holder>
                                <div className="vendor-name">
                                    <h6>{props.vendor.VendorName}</h6>
                                </div>
                            </Col>
                        </OverlayTrigger>
                        :

                        <Col md={2} className="text-center vendor-wrapper">
                            <Holder>
                                <div className="logo-wrapper">
                                    <Image src={props.vendor.VendorLogoLink} className="vendor-logo" rounded />
                                </div>
                            </Holder>
                            <div className="vendor-name">
                                <h6>{props.vendor.VendorName}</h6>
                            </div>
                        </Col>
                }
            </>
        )
    }

    // SelectedApps and remaining apps state maintainer
    const selectionUpdator = (select) => {
        const selected_app = allVendors.filter((obj) => {
            return obj.VendorName === select;
        })[0]
        const appset = new Set(getFromLS("appset"))
        console.log("ALL NEEDED APP: ", appset)
        if (!appset.has(selected_app.VendorId)) {
            if (selected_app.Active === "Y") {
                selected_app.Active = "N"
            } else {
                selected_app.Active = "Y"
            }

            if (selectedAppsMapper.includes(selected_app)) {
                const index = selectedAppsMapper.indexOf(selected_app);
                if (index > -1) { // only splice selectedApp if app already exists
                    selectedAppsMapper.splice(index, 1); // 2nd parameter means remove one item only
                }
                remainingAppsMapper.push(selected_app)
                setSelectedAppsMapper([...selectedAppsMapper])
                setRemainingAppsMapper([...remainingAppsMapper])
            } else {
                const index = remainingAppsMapper.indexOf(selected_app);
                if (index > -1) { // only splice remainingApp if app already exists
                    remainingAppsMapper.splice(index, 1); // 2nd parameter means remove one item only
                }
                selectedAppsMapper.push(selected_app)
                setSelectedAppsMapper([...selectedAppsMapper])
                setRemainingAppsMapper([...remainingAppsMapper])
            }
        } else {
            console.log("YOU SHOULD NOT DESELECT THE APP FOR WHICH THE FLOWS ALREADY EXIST.")
        }
    }

    // useEffect(() => {

    // }, [selectedAppsMapper, remainingAppsMapper, selectedApps, remainingApps])


    // Vendor app filterer and search handler
    const handleSearch = (target, filter = false, nestedFilter = false) => {
        // target is the searched text
        // filter is if select filter is used
        // nested filter is on top of select filter serarch text is used
        if (filter) {
            setIsFilterOn(filter)
            setSearchEnabled(true)
            if (target == null) {
                setIsFilterOn(false)
                setAllVendorsMapper([...selectedApps, ...remainingApps])
                setSelectedAppsMapper([...selectedApps])
                setRemainingAppsMapper([...remainingApps])
                setComingSoonAppsMapper([...comingSoonApps])
            } else {
                if (nestedFilter) {
                    if (target == null) {
                        setSelectedAppsMapper(filteredSelectedApps)
                        setRemainingAppsMapper(filteredRemainingApps)
                        setComingSoonAppsMapper(filteredComingSoonApps)
                    } else {
                        if (target == "") {
                            setSelectedAppsMapper(filteredSelectedApps)
                            setRemainingAppsMapper(filteredRemainingApps)
                            setComingSoonAppsMapper(filteredComingSoonApps)
                        }
                        else {
                            const updatedSelectedVendors = filteredSelectedApps.filter((obj) => {
                                return obj.VendorName.toLowerCase().includes(target.toLowerCase());
                            })
                            const updatedRemainingVendors = filteredRemainingApps.filter((obj) => {
                                return obj.VendorName.toLowerCase().includes(target.toLowerCase());
                            })
                            const updatedComingSoonVendors = filteredComingSoonApps.filter((obj) => {
                                return obj.VendorName.toLowerCase().includes(target.toLowerCase());
                            })
                            setSelectedAppsMapper(updatedSelectedVendors)
                            setRemainingAppsMapper(updatedRemainingVendors)
                            setComingSoonAppsMapper(updatedComingSoonVendors)
                        }
                    }
                }
                else {
                    if (target == null) {
                        setSelectedAppsMapper(filteredSelectedApps)
                        setRemainingAppsMapper(filteredRemainingApps)
                        setComingSoonAppsMapper(filteredComingSoonApps)
                    } else {
                        const updatedSelectedVendors = selectedApps.filter((obj) => {
                            return obj.Category === target.label;
                        })
                        const updatedRemainingVendors = remainingApps.filter((obj) => {
                            return obj.Category === target.label;
                        })
                        const updatedComingSoonVendors = comingSoonApps.filter((obj) => {
                            return obj.Category === target.label;
                        })
                        setFilteredSelectedApps(updatedSelectedVendors)
                        setFilteredRemainingApps(updatedRemainingVendors)
                        setFilteredComingSoonApps(updatedComingSoonVendors)
                        setSelectedAppsMapper(updatedSelectedVendors)
                        setRemainingAppsMapper(updatedRemainingVendors)
                        setComingSoonAppsMapper(updatedComingSoonVendors)
                        setAllVendorsMapper([...updatedSelectedVendors, ...updatedRemainingVendors, ...updatedComingSoonVendors])
                    }
                }
            }
        }
        else {
            // This means that only simple search is used
            setSearchEnabled(false)
            if (target == "") {
                setSearchEnabled(false)
                setSelectedAppsMapper(selectedApps)
                setRemainingAppsMapper(remainingApps)
                setComingSoonAppsMapper(comingSoonApps)
                setAllVendorsMapper([...selectedApps, ...remainingApps, ...comingSoonApps])
            } else {
                setAllVendorsMapper([...selectedApps, ...remainingApps, ...comingSoonApps])
                const updatedVendors = [...selectedApps, ...remainingApps, ...comingSoonApps].filter((obj) => {
                    return obj.VendorName.toLowerCase().includes(target.toLowerCase());
                })
                setAllVendorsMapper(updatedVendors)
                const updatedSelectedVendors = selectedApps.filter((obj) => {
                    return obj.VendorName.toLowerCase().includes(target.toLowerCase());
                })
                const updatedRemainingVendors = remainingApps.filter((obj) => {
                    return obj.VendorName.toLowerCase().includes(target.toLowerCase());
                })
                const updatedComingSoonVendors = comingSoonApps.filter((obj) => {
                    return obj.VendorName.toLowerCase().includes(target.toLowerCase());
                })

                setFilteredSelectedApps(updatedSelectedVendors)
                setFilteredRemainingApps(updatedRemainingVendors)
                setFilteredComingSoonApps(updatedComingSoonVendors)
                setSelectedAppsMapper(updatedSelectedVendors)
                setRemainingAppsMapper(updatedRemainingVendors)
                setComingSoonAppsMapper(updatedComingSoonVendors)
                setAllVendorsMapper([...updatedSelectedVendors, ...updatedRemainingVendors, ...updatedComingSoonVendors])
            }
        }
    }

    useEffect(() => {
        setVendorCategoriesOptions(optionRenderer(vendorCategories))
        setTimeout(() => {
            setIsSelectOptionsLoading(false)
        }, 2000);
    }, [vendorCategories])

    const transporter = (pill) => {
        setTimeout(() => {
            props.transporter(pill);
        }, 3000);
    };

    const transportTo = () => {
        if (getFromLS('intent') == undefined) {
            navigate("/intent", { replace: true })
        } else {
            transporter("recommendation")
        }
    }

    return (
        <>
            {activeVendors && (
                <Row className="no-gutter">
                    <h3 className="display-6">What apps do you use? </h3>
                    <h5 style={{ margin: "10px 0px 30px 10px" }}>We’ll give you personalized integration recommendations based on the apps you choose.</h5>
                    <Row className="flex-row-center-start">
                        <Col xs={7} className="vendor-search">
                            <input className="search-bar custom-input"
                                type="text" placeholder="&#xF002; Search vendor apps"
                                style={{ fontFamily: "Poppins, FontAwesome" }}
                                onChange={(event) => handleSearch(event.target.value, isFilterOn, isFilterOn ? true : false)}
                            />
                        </Col>
                        <Col xs={3}>
                            <Select
                                options={vendorCategoriesOptions}
                                aria-label="Default"
                                closeMenuOnSelect={true}
                                autosize={true}
                                placeholder="Filter by categories"
                                menuPosition="fixed"
                                onChange={(e) => handleSearch(e, true)}
                                isLoading={isSelectOptionsLoading}
                                className='custom-select '
                                classNamePrefix="react-select"
                                isClearable
                            />
                        </Col>
                        <CustomButton
                            progress={handleVendorSaveApiFlag}
                            onclick={() => handleVendorsSave()}
                            content={handleVendorSaveApiFlag ? "Saving" : "Save"}
                            disable={handleVendorSaveApiFlag}
                        />
                    </Row>
                    <div className="select-vendor-container text-center">
                        <Row>
                            {
                                selectedAppsMapper == [] ? <p></p> :
                                    <span className="selected-row-title">
                                        Selected apps
                                    </span>
                            }
                            {
                                selectedAppsMapper &&
                                selectedAppsMapper.map(option => (
                                    <VendorCard
                                        vendor={all_vendors[option.VendorCode]}
                                        key={all_vendors[option.VendorCode].VendorCode}
                                        id={all_vendors[option.VendorCode].VendorCode}
                                    />
                                ))
                            }
                            {remainingAppsMapper == [] ? <p></p> :
                                <span className="remaining-row-title">
                                    Available apps
                                </span>}
                            {
                                remainingAppsMapper &&
                                remainingAppsMapper.map(option => (
                                    <VendorCard
                                        vendor={all_vendors[option.VendorCode]}
                                        key={all_vendors[option.VendorCode].VendorCode}
                                        id={all_vendors[option.VendorCode].VendorCode}
                                    />
                                ))
                            }
                            {
                                comingSoonAppsMapper.length == 0 ? <p></p> :
                                    <span className="remaining-row-title">
                                        Upcoming apps
                                    </span>
                            }
                            {
                                comingSoonAppsMapper &&
                                comingSoonAppsMapper.map(option => (
                                    <VendorCard
                                        vendor={all_vendors[option.VendorCode]}
                                        key={all_vendors[option.VendorCode].VendorCode}
                                        id={all_vendors[option.VendorCode].VendorCode}
                                        disabled={true}
                                    />
                                ))
                            }
                        </Row>
                    </div>
                </Row>

            )}
        </>
    );
}

export default FirmDetails;
